import { message } from 'antd';
import { RecordInfoDrawer } from 'components/RecordInfoDrawer';
import { TableHeader } from 'components/TableHeader';
import { DELETE_ERROR, FETCH_ERROR, SUCCESS_DELETE } from 'constants/alerts';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { useDrawers } from 'hooks/useDrawers';
import { useHeaderChanger } from 'hooks/useHeaderChanger';
import { usePagination } from 'hooks/usePagination';
import React, { useCallback, useEffect, useState } from 'react';
import { PartnersService } from 'services/PartnersService';
import { PartnersForm } from './PartnersForm';
import { PartnersTable } from './PartnersTable';

function Partners() {
  useDocumentTitle('Партнеры');
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(false);
  const { setCount } = useHeaderChanger('Партнеры');
  const {
    state: { drawerVisible, formIsActive, activeRecord },
    openDrawer,
    closeDrawer,
    openCreateForm,
    openEditForm,
    closeForm,
  } = useDrawers();
  const { page, perPage, totalRows, setPagination, setTotalRows } =
    usePagination();

  const fetchPartners = useCallback(async () => {
    if (!page || !perPage) {
      return;
    }

    setLoading(true);

    try {
      const { items, total } = await PartnersService.getPartners({
        page,
        perPage,
      });
      setPartners(items);
      setTotalRows(total);
      setCount(total);
    } catch (err) {
      message.error(FETCH_ERROR);
    } finally {
      setLoading(false);
    }
  }, [page, perPage]);

  useEffect(() => fetchPartners(), [fetchPartners]);

  const handleDelete = async () => {
    try {
      const isDeleted = await PartnersService.deletePartner(activeRecord?.id);

      if (isDeleted) {
        closeDrawer();
        fetchPartners();
        message.success(SUCCESS_DELETE);
      }
    } catch (err) {
      message.error(DELETE_ERROR);
    }
  };

  return (
    <>
      <TableHeader onCreate={openCreateForm} pageId="businessPartner" />

      <PartnersTable
        items={partners}
        loading={loading}
        current={page}
        pageSize={perPage}
        onRowClick={openDrawer}
        total={totalRows}
        onChange={setPagination}
      />

      <RecordInfoDrawer
        record={activeRecord}
        drawerTitle={activeRecord?.title}
        recordFields={[
          { label: 'Наименование', key: 'title' },
          { label: 'Имя пользователя', key: 'username' },
          { label: 'Код', key: 'code' },
        ]}
        isVisible={drawerVisible}
        onClose={closeDrawer}
        onEdit={openEditForm}
        onDelete={handleDelete}
        deleteConfirmText="Вы точно хотите удалить этого партнера ?"
        pageId="businessPartner"
      />

      <PartnersForm
        isActive={formIsActive}
        initialValues={activeRecord}
        onSuccess={fetchPartners}
        onClose={closeForm}
      />
    </>
  );
}

export { Partners };
